import React, {useEffect, useState} from 'react';
import ComponentCard from "../../microComponents/elements/ComponentCard";

const CardBox = ({icon, title, value}) => {
    const [val, setVal] = useState(value)
    useEffect(() => {
        setVal(value)
    }, [value]);
     return (
        <ComponentCard>
            <div className='flex justify-between items-center w-full p-1'>
                <div>
                    <div className="text-gray-400 text-sm mb-1">{title}</div>
                    <div className="text-gray-800 text-xl font-bold ">{val}</div>
                </div>
                <div className="">
                    {icon}
                </div>
            </div>
        </ComponentCard>
    );
};

export default CardBox;